/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
    // Add custom code below this line

    const initVideoControls = () => {
        document.addEventListener('click', function (e) {
            // 1. Detect which button was clicked (or its parent)
            const soundToggle = e.target.closest('[data-video-sound-toggle]');
            const playToggle = e.target.closest('[data-video-play-toggle]');

            // If neither button was clicked, exit
            if (!soundToggle && !playToggle) return;

            e.preventDefault();

            // 2. Find the video element relative to the clicked button
            const container = (soundToggle || playToggle).closest('.index-hero--video');
            const video = container ? container.querySelector('video') : null;

            if (!video) {
                console.warn('Video element not found.');
                return;
            }

            // 3. Handle Sound Toggle
            if (soundToggle) {
                video.muted = !video.muted;
                soundToggle.classList.toggle('is-muted', video.muted);
                soundToggle.setAttribute('aria-pressed', !video.muted);
            }

            // 4. Handle Play/Pause Toggle
            if (playToggle) {
                if (video.paused) {
                    video.play();
                    playToggle.classList.remove('is-paused');
                } else {
                    video.pause();
                    playToggle.classList.add('is-paused');
                }
                playToggle.setAttribute('aria-pressed', video.paused);
            }
        });
    };

    initVideoControls();

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
